module.exports = __webpack_public_path__ + "img/img_bi_line_logo.009846ee.png";